<section class="tfgApplication">
    <div class="container">
        <!-- Reg HTML Start -->

        <div class="login-hld">

                <div class="d-flex flex-wrap align-items-stretch">

                    <div class="col-lg-6 col-md-7 regsterfrm px-3">
<!-- Continue your application section -->
                                    <div class="tfg-whatsapp-continue">
                                        <div>
                                            <div class="tfg-whatsapp-continue-title"><span class="font-bolder">Continue</span> your TFG application</div>
                                            <div class="border-blue"></div>
                                            <div class="tfg-whatsapp-continue-text">For WhatsApp web click on the link below:</div>
                                            <div class="tfg-whatsapp-continue-link-wrap">
                                                <a href="https://l.ead.me/bg8S7c" target="_blank" class="tfg-whatsapp-continue-link">{{ whatsappUrl }}</a>
                                            </div>
                                            <div class="tfg-whatsapp-continue-text margin_class">OR</div>
                                            <div class="tfg-whatsapp-continue-text">Scan QR code to continue on mobile:</div>
                                            <div>
                                                <img src="/assets/images/TFG_QR.png" alt="WhatsApp QR Code" class="tfg-whatsapp-continue-qr">
                                            </div>
                                            <!-- Response message area -->
                                            <div *ngIf="responseMessage" class="tfg-whatsapp-response">
                                                {{ responseMessage }}
                                            </div>
                                        </div>
                                    </div>

                    </div>

                    <div class="col-lg-6 col-md-5 d-flex flex-wrap pt-lg-3 ps-lg-5 ps-3 pe-lg-3 pe-3 boxblue align-items-stretch">


                        <section class="d-flex align-items-stretch w-100 flex-wrap ps-lg-5">
                          <figure class="m-0 p- ps-md-5 d-md-block d-none w-100">
                            <div class="bgmg position-relative">
                                <img ngOptimizedImage  [src]="defaultImage" class="ps-lg-5" alt=""/>
                            </div>
                        </figure>

                                <div class="helpline position-relative d-flex flex-wrap w-100">
                                    <div class="col-md-12 col-12 px-3 center-align">
                                        <h2 class="mb-3 loginpage-caption bottomline">Need <b class="font-bolder"> help?</b></h2>
                                        <a class="phhelp" href="tel:+27860726526">+27 86 006 1058</a>
                                        <p class="mt-3 horset">Monday – Thursday 07:00-17:00</p>
                                        <p class="mt-3 horset">Friday 07:00-16:00</p>
                                    </div>
                                </div>

                        </section>
                    </div>
                </div>

                                    




               
        </div>

    
        <!-- REG HTML Start -->
    </div>



   

</section>